<template>
	<div class="review-popup-content container mb-5 mt-md-5 cursor-default">
		<div
			class="d-flex flex-column flex-md-row bg-white shadow-3 border-grey-300 p-4 mt-3 m-md-3 position-relative"
			style="border-radius: var(--border-radius-secondary)"
		>
			<button
				@click="handleClosePopup"
				class="ts-x-black ts-x-md position-absolute review-popup-cls"
			></button>
			<!-- <ClsBtn
				@click="handleClosePopup"
				:classes="'review-popup-cls position-absolute'"
			/> -->
			<div class="pe-5 d-flex flex-column justify-content-center gap-1">
				<div class="d-flex body-strong text-grey-900">
					<span v-if="review.authorName">{{ review.authorName }}.</span>
					<span>{{ " " }}</span>
					<span v-if="review.authorSurname">{{ review.authorSurname }}</span>
				</div>
				<div class="body text-grey-600 text-nowrap">
					<span class="content-date">{{ review.creationDate }}</span>
				</div>
				<div class="mb-2 d-flex align-items-center">
					<span class="content-rating body-strong text-grey-900 me-1"
						>{{ this.fomattedRatingByLocale }}/5</span
					>
					<svg class="icon mb-1 text-primary-blue" width="16" height="16">
						<use xlink:href="#___icon___star-full"></use>
					</svg>
				</div>
			</div>
			<div>
				<template v-if="review.customerComment">
					<div class="body text-grey-900 pe-3">
						<span class="content-text">{{ review.customerComment }}</span>
					</div>
					<div class="border border-1 border-gray my-4"></div>
				</template>
				<Summary :ratings="ratings" />
			</div>
		</div>
	</div>
</template>

<script>
import Summary from "../common/summary.vue";
import { mapState } from "vuex";

export default {
	name: "ReviewPopup",
	props: {
		review: {
			type: Object,
			default: () => {
				return {};
			},
		},
		open: {
			type: Boolean,
			default: false,
		},
		ratings: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	components: {
		Summary,
	},
	methods: {
		getCreatedDatePretty(dateStr) {
			const dateObj = new Date(dateStr);
			const options = { year: "numeric", month: "long", day: "numeric" };
			return dateObj.toLocaleString(this.language, options);
		},
		handleClosePopup() {
			this.$emit("closePopup");
		},
	},
	computed: {
		...mapState(["language"]),
		fomattedRatingByLocale() {
			const formattedReview = this.review.avgLihe
				.toFixed(1)
				.replace(/\.0$/, "");

			if (this.language === "fr-FR" || this.language === "fr-FR-CSE") {
				return formattedReview.replace(".", ",");
			} else {
				return formattedReview;
			}
		},
	},
};
</script>

<style scoped>
.review-popup-cls {
	right: 10px;
	top: 10px;
}
</style>
